import React from "react";

type MeetingsSidePanelAttendeesProps = {
  title: string;
  attendees: string[];
};

export const MeetingsSidePanelAttendees: React.FC<MeetingsSidePanelAttendeesProps> = ({
  title,
  attendees,
}) => {
  return (
    <div className="MeetingsSidePanelAttendees">
      <div className="MeetingsSidePanelAttendees__title">{title}</div>
      <div className="MeetingsSidePanelAttendees__attendees">
        {attendees && Array.isArray(attendees) && attendees.length > 0 ? (
          attendees.map((attendee, idx) => (
            <div key={idx} className="MeetingsSidePanelAttendees__attendee">
              {attendee}
            </div>
          ))
        ) : (
          <div className="MeetingsSidePanelAttendees__attendee">
            No attendees found
          </div>
        )}
      </div>
    </div>
  );
};
